import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type ThreeStepCardsLayoutProps = {
  children: React.ReactNode;
  variant?: 'grid' | 'horizontal';
};
export function ThreeStepCardsLayout(t0) {
  const $ = _c(3);
  const {
    children,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "grid" : t1;
  const t2 = variant === "grid" ? "grid w-full max-w-5xl grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8" : "flex w-full max-w-5xl flex-col gap-8";
  let t3;
  if ($[0] !== children || $[1] !== t2) {
    t3 = <div className="flex min-w-0 flex-col items-center"><ol className={t2}>{children}</ol></div>;
    $[0] = children;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}